@if (displayedQuantity) {
{{ displayedQuantity }}
} @else {
<ng-container i18n="Size Grid|Empty cell character@@emptyCellCharacter"
  >-</ng-container
>
}
